@if (this.specificConfig.showLabel) {
	<div class="d-flex align-items-center gap-1">
		<h6 class="m-0 d-flex">
			<label [for]="'multiSelectFilter' + specificConfig.id">{{ specificConfig.label }}:</label>
		</h6>
	</div>
}

<div
	[id]="'multiSelectFilter' + specificConfig.id"
	#multiSelect
	role="listbox"
	aria-multiselectable="true"
	tabindex="0"
	class="multi-select"
	aria-labelledby="multi-select-label">
	@for (option of specificConfig.options; track option.primaryValue) {
		<label [attr.data-index]="$index">
			<input
				(click)="onOptionChange(option.primaryValue)"
				type="checkbox"
				[value]="option.primaryValue"
				[attr.secondaryValue]="option.secondaryValue"
				[checked]="
					this.specificConfig.defaultValues.includes(option.primaryValue) ||
					this.specificConfig.defaultValues.includes(option.secondaryValue)
						? true
						: null
				" />
			{{ option.label }}
		</label>
	}
</div>
@if (this.specificConfig.maxSelected) {
	<span aria-live="polite"
		>Valori selezionati: {{ this.numberOfSelected }} (max. {{ this.specificConfig.maxSelected }})</span
	>
	<app-info-button
		[modalId]="'selectedValuesModal-' + specificConfig.id"
		title="Visualizza valori selezionati."></app-info-button>
}

<app-modal [modal]="this.selectedValuesLabelModal" [modalId]="'selectedValuesModal-' + specificConfig.id"></app-modal>
